import React, { useState } from "react";
import ProductSlider from "../content_creator/ProductSlider";
import { CloseOutlined } from '@ant-design/icons';
import { addCommas, dateFormat, parseAuthorsPlain } from "../utils/Utils";
import { apiDownload } from "../utils/Api";
import ListCopy from "./ListCopy";
import ListDelete from "./ListDelete";
import ListNotes from "./ListNotes";
import moment from "moment-timezone";
import { Alert, Button, Divider, Image, Input, message, Space, Tag, Typography } from "antd";
import conditional from "../utils/conditional";
import Html from "../utils/Html";
import Overlay from "../util_components/Overlay";
import ListEdit from "./ListEdit";
import Title from "./Title";
import Renderer from "./Renderer";
import ListCreatePdf from "./ListCreatePdf";
import ListCreateExcel from "./ListCreateExcel"
import { useSession } from "../utils/Session";
import BusinessContactInfo from "./BusinessContactInfo";
export default function List(props) {

    const [session, setSession] = useSession();
    const { data = {}, divider = true, results = {}, setResults = () => { } } = props;

    const {
        list_id = "",
        actual_id = 0,
        is_dynamic = false,
        owner_name = "",
        user_name = "",
        category = "",
        is_catalogue = false,
        in_list = false,
        subcategory = "",
        season = "",
        vendor = { name: "", acct: "", id: "" },
        agency = { name: "", acct: "", id: "" },
        subject = "",
        note = "",
        note_posted = "",
        name = "",
        date_posted = null,
        date_updated = null,
        date_created = null,
        date_expired = null,
        views = null,
        description = "",
        folder = "",
        is_starred = false,
        is_archived = false,
        is_deleted = false,
        onhand = null,
        onorder = null,
        sequence = null,
        isbns = [],
        isbns_count = 0,
        site_content = false,
        bookmark_data = null,
        has_linked_pdf = false,
    } = data;


    const [expanded, setExpanded] = useState(false)


    const toggleExpanded = (_id) => {
        if (expanded === _id) {
            setExpanded(false)
        } else {
            setExpanded(_id);
        }
    }


    const drawComponent = () => { }

    const linkOut = (_id) => {
        window.open("/browse/filter/x/" + _id + "/v/sequence", "_blank");
    }

    const ListImage = (props) => {
        const { img = {} } = props;

        const [imgError, setImageError] = useState(false);
        return (
            <>
                {(imgError && <>
                    <div style={{ "height": "150px", "width": "110px" }} className="card-fallback-small">
                        <div style={{ "fontSize": "12px", "whiteSpace": "normal", "maxWidth": "100px" }}>{img.title}</div>
                        <div className="shim" /><div className="shim" />
                        <div style={{ "fontSize": "13px", "whiteSpace": "normal", "maxWidth": "100px", "opacity": "0.8" }}><small><em>{parseAuthorsPlain(img.authors)}</em></small></div>
                    </div>
                </>)}
                {(!imgError && <>
                    <img className="shadow-large" style={drawImage(img.highlight)} onError={(e) => setImageError(true)} src={"https://cdn1.bookmanager.com/i/slider_23.php?b=" + img.eisbn + "&b2b=" + img.cover_image_key + "&cb=" + img.cover_image_cache} />
                </>)}

            </>

        )
    }

    const downloadPDF = () => {
        apiDownload({ list_id: list_id }, "titlelist/getLinkedPdf")
    }

    function drawCardBorder(highlight) {
        if (highlight) {
            return {
                top: "-15px",
                lineHeight: "12px",
                padding: "1px 2px",
                backgroundColor: "#ff0099",
            }
        }
        return {
            top: "-15px",
            lineHeight: "12px",
            padding: "1px 2px",
        }
    }

    const drawExpired = () => {
        if (date_expired) {
            return (<div><small style={{ "color": "#f12a46" }}>Catalogue expires {moment(date_expired * 1000).format("MMMM D YYYY")}</small></div>)
        } else {
            return (<></>)
        }
    }

    function drawImage(highlight) {
        if (highlight) {
            return {
                borderStyle: "solid",
                borderColor: "#ff0099",
                borderWidth: "3px",
                maxHeight: "150px",
            }
        }
        return {
            maxHeight: "150px",
        }
    }


    const CopyButton = (props) => {
        const { path = "" } = props
        const [copied, setCopied] = useState(false);

        const copyToClipboard = (_str) => {
            if (!navigator.clipboard) {
                message.error("Can't copy");
                return;
            }
            navigator.clipboard.writeText(path);
            setCopied(true);
            setTimeout(() => {
                setCopied(false)
            }, 1000);
        }

        return (<Button onClick={(e) => copyToClipboard(e)} type={(copied ? "default" : "primary")}>{(copied) ? "Copied" : "Copy"}</Button>);

    }


    const Share = (props) => {


        return (
            <div style={{ "padding": "20px" }}>

                <h3>Share</h3>
                <div aria-hidden><Divider /></div>
                <p>To share this with others, copy this link (e.g. Ctrl-C) and then paste it into an email.</p>
                <div className="shim"></div>
                <Input value={"https://bookmanager.com/browse/filter/x/" + list_id + "/v/sequence"}></Input>
                <div className="shim"></div><div className="shim"></div><div className="shim"></div><div className="shim"></div>
                <div style={{ "float": "right" }}><Space><CopyButton path={"https://bookmanager.com/browse/filter/x/" + list_id + "/v/sequence"} /> <Button onClick={() => props.close()}>Close</Button></Space></div>
                <br clear="all" />

            </div>
        )

    }


    return (
        <div key={list_id}>
            <div className="shim" /><div className="shim" />
            <div className="hideHover">
                <div className="float-flex">
                    <div>
                        <Typography.Title style={{ "lineHeight": "17px" }} level={5}>
                            <conditional.true value={has_linked_pdf}>
                                <Image
                                    preview={false}
                                    style={{ "cursor": "pointer", "marginRight": "10px", "marginTop": "7px" }}
                                    width="30px"
                                    height="30px"
                                    src="https://bookmanager.com/i/pdf.png"
                                    onClick={() => downloadPDF()}
                                />
                            </conditional.true>
                            <a onMouseDown={(e) => {
                                if (e.button > 0) {
                                    linkOut(list_id)
                                }
                            }} onClick={() => linkOut(list_id)}>
                                {name} <small style={{ "fontWeight": "normal" }} className="c" > - {addCommas(isbns_count)} titles  {(is_dynamic && <><small><em>(Dynamic)</em></small></>)}</small>
                            </a>
                            <br clear="both" />
                            <span className="c" style={{ "fontSize": "13px", "display": "block", "marginTop": "5px" }}>
                                <Overlay width={700} component={<div style={{ "padding": "20px" }}><strong>Contact</strong><Divider dashed style={{ "margin": "10px 0px" }} /><div className="shim" /><div style={{ "margin": "-8px" }}><BusinessContactInfo id={vendor?.id} /></div></div>}><a style={{ "textAlign": "left", "maxWidth": "250px", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>{vendor?.name}</a></Overlay>
                            </span>
                            <span className="c" style={{ "fontSize": "13px", "display": "block" }}>
                                <Overlay width={700} component={<div style={{ "padding": "20px" }}><strong>Contact</strong><Divider dashed style={{ "margin": "10px 0px" }} /><div className="shim" /><div style={{ "margin": "-8px" }}><BusinessContactInfo id={agency?.id} /></div></div>}><a style={{ "textAlign": "left", "maxWidth": "250px", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>{(agency?.name) ? <>REP: {agency?.name}</> : <></>}</a></Overlay>
                            </span>

                            <Space>
                                {(is_catalogue && category && <span style={{ "color": "#999", "fontSize": "12px", "display": "block" }}><em><span style={{ "fontWeight": "normal" }}>Category:</span> {category}</em></span>)}
                                {(is_catalogue && season && <span style={{ "color": "#999", "fontSize": "12px", "display": "block" }}><em><span style={{ "fontWeight": "normal" }}>Season: </span>{season}</em></span>)}
                                {(is_catalogue && <span style={{ "color": "#999", "fontSize": "12px", "display": "block", "fontWeight": "normal" }}><em>List: {actual_id} </em></span>)}
                                {/* {(folder && <span style={{ "color": "#999", "fontSize": "12px", "display": "block", "fontWeight": "normal" }}><em>Folder:<ListFolder type="link" getLists={props.getLists} folder={folder} list_id={list_id} isbns={isbns} >{folder} </ListFolder></em>&nbsp;</span>)} */}
                            </Space>
                            {is_catalogue && drawExpired()}
                            {(is_catalogue && <div className="shim" />)}
                        </Typography.Title>
                    </div>
                    <div>
                        <conditional.true value={is_catalogue}>
                            <div style={{ "float": "right", "textAlign": "right" }}>
                                <Typography.Paragraph style={{ "fontSize": "12px" }}>
                                    <Space size={0}>

                                        {/* <ListFav getLists={props.getLists} list={data} results={results} setResults={setResults} />
                                    <ListArchive list={data} results={results} setResults={setResults} />
                                    <ListTrash list={data} results={results} setResults={setResults} />
                                    {(is_catalogue && <ListFolder getLists={props.getLists} folder={folder} list_id={list_id} isbns={isbns} icon={true} ></ListFolder>)} */}

                                    </Space>
                                </Typography.Paragraph>

                                <Typography.Paragraph style={{ "fontSize": "12px" }}>
                                    <conditional.true value={(date_updated)}>
                                        <span>Updated: </span><span style={{ "fontWeight": "normal" }}>{dateFormat(date_updated)}</span><br />
                                    </conditional.true>
                                    <conditional.true value={(date_posted && is_catalogue)}>
                                        <span style={{ "color": "#999", "fontSize": "12px", "display": "block", "fontWeight": "normal" }}><em>Posted: {dateFormat(date_posted)}</em></span>
                                    </conditional.true>
                                    {(owner_name && <span style={{ "color": "#999", "fontSize": "12px", "display": "block", "fontWeight": "normal" }}><em>Managed by: {owner_name}</em></span>)}
                                    {(user_name && <span style={{ "color": "#999", "fontSize": "12px", "display": "block", "fontWeight": "normal" }}><em>Updated by: {user_name}</em></span>)}
                                </Typography.Paragraph>
                            </div>
                        </conditional.true>
                    </div>
                </div>

                {(is_catalogue && <div className="shim" />)}
                {/* Max 11 wide */}
                <div style={{ maxWidth: "1200px", width: "calc(100vw - 50px)" }}>
                    <ProductSlider callback={(e) => toggleExpanded(e.eisbn)} content={{ data: { display_mode: "scroller", padding_x: 0, list_id: list_id }, injected_data: { items: { rows: isbns, row_count: isbns_count } } }} />
                </div>
            </div>

            <conditional.true value={(description && !site_content)}>
                <div><div className="shim" /><div className="shim" /><span style={{ "color": "#999", "fontSize": "12px", "display": "block", "fontWeight": "normal" }}><Html html={description} /></span><div className="shim" /></div>
            </conditional.true>


            <conditional.true value={(note)}>
                <div style={{ "maxWidth": "500px" }}>
                    <Alert style={{ "padding": "5px 10px" }} type="warning" description={<div style={{ "marginTop": "-10px" }}><small>{note}</small></div>} message={<div><small><div style={{ "float": "right" }}>{(note_posted) ? <small>{moment(note_posted * 1000).format("MMM D, YYYY")}</small> : ""}</div> Private notes:</small></div>} />
                    <br />
                </div>
            </conditional.true>

            <Space size={0}>
                {((data?.category !== "Wishlist" && !is_catalogue) && <Tag className="tag-btn cataloguebtn" color={"#999"}><Overlay maskClosable={false} width={700} component={<ListEdit results={results} setResults={setResults} data={data} />}><span style={{ "cursor": "pointer" }}>Edit</span></Overlay></Tag>)}
                {/* {((!is_catalogue) && <Tag className="tag-btn cataloguebtn" color={disabledColor}><Overlay maskClosable={false} width={700} component={<ListEdit results={results} setResults={setResults} data={data} />}>Edit</Overlay></Tag>)}
                {(!is_dynamic && <Tag className="tag-btn cataloguebtn" color={disabledColor}><Overlay width={450} component={<ListsCopy results={results} setResults={setResults} list_id={list_id} name={name} />}>Copy</Overlay></Tag>)}
                <Tag className="tag-btn cataloguebtn" color={disabledColor}><Overlay component={<ListCreateExcel list_id={list_id} />} width={500}>Excel</Overlay></Tag>
                <Tag className="tag-btn cataloguebtn" color={disabledColor}><Overlay component={<ListCreatePdf is_catalogue={is_catalogue} count={isbns_count} list_id={list_id} />} width={500}>PDF</Overlay></Tag>
                <Tooltip title={<small>Open a new tab to with a printable version. Max 500 titles.</small>}>
                </Tooltip>
                // <Tag className="tag-btn cataloguebtn" color={disabledColor}><Overlay width={520} component={<ListShare list_id={list_id} />}>Share</Overlay></Tag> */}
                {(!is_dynamic && (session.logged_in) && <Tag className="tag-btn cataloguebtn" color={"#999"}><Overlay width={450} component={<ListCopy results={results} setResults={setResults} list_id={list_id} name={name} />}>Copy</Overlay></Tag>)}
                {((!is_catalogue) && <ListDelete name={name} results={results} setResults={setResults} list_id={list_id} ><Tag className="tag-btn cataloguebtn" color={"#999"}>Delete</Tag></ListDelete>)}
                {(session.logged_in && <Tag className="tag-btn cataloguebtn" color={"#999"}><Overlay width={450} component={<ListNotes results={results} setResults={setResults} note={note} list_id={list_id} />}>My Notes</Overlay></Tag>)}   
                {/* <Tag className="tag-btn cataloguebtn" color={"#999"}><Overlay width={520} component={<ListShare list_id={list_id} />}>Share</Overlay></Tag> */}

            
                {(session.has_bestsell && (session.has_bm_data_lite || session.has_bm_data_full) &&
                    <Tag className="tag-btn cataloguebtn" color={"#999"}><Overlay component={<ListCreateExcel list_id={list_id} />} width={500}>Excel</Overlay></Tag>
                )}
                {(session.has_bestsell && (session.has_bm_data_lite || session.has_bm_data_full) &&
                    <Tag className="tag-btn cataloguebtn" color={"#999"}><Overlay component={<ListCreatePdf is_catalogue={is_catalogue} count={isbns_count} list_id={list_id} />} width={500}>PDF</Overlay></Tag>
                )}
                <Tag onClick={() => window.open("/print/list/" + list_id, "_blank")} color={"#999"} className="tag-btn cataloguebtn" >Print</Tag>
                <Tag className="tag-btn cataloguebtn" color={"#999"}><Overlay width={520} component={<Share />}>Share</Overlay></Tag>
            </Space>

            {(expanded && <>
                <div className="shim" />
                <div className="hideHover" style={{ "marginTop": "0px", "marginLeft": "0px", "marginRight": "0px", "maxWidth": "1210px" }}>
                    <div style={{ "padding": "0 0px" }}>
                        <div style={{ "marginTop": "0px", "borderTop": "none", "backgroundColor": "#f1f1f1" }} className="closebar">
                            <Button style={{ "float": "right" }} onClick={() => setExpanded(false)} size="small" type="text" icon={<small><CloseOutlined style={{ "fontSize": "10px", "color": "#111" }} /></small>} />
                            <br clear="both" />
                        </div>
                    </div>
                    <div style={{ "padding": "10px 0px", "backgroundColor": "#fff" }}>
                        <Renderer record_key={expanded} >
                            <Title divider={false} view={"details"} list_id={list_id} load_id={expanded} />
                        </Renderer>
                    </div>
                </div>
            </>)}
            {(divider && <Divider dashed />)}
        </div>
    );

}
